const VectorMountainsFar = ({ className }: { className?: string }) => (
    <svg
        className={className}
        viewBox="0 0 200 100"
        preserveAspectRatio="none"
    >
        <path
            d="M0,100 L40,30 L80,45 L120,15 L160,25 L200,20 L200,100 Z"
            fill="#1a2332"
        />
    </svg>
);

export default VectorMountainsFar;
